import { useRunBambiRun } from './useRunBambiRun';
import { useSelectAllUnassignedTrips } from './useSelectAllUnassignedTrips';

export function useDispatchToolbarActions() {
  const runBambiRun = useRunBambiRun();
  const selectAllUnassignedTrips = useSelectAllUnassignedTrips();

  return {
    runBambiRun: runBambiRun.start,
    onSelectAll: selectAllUnassignedTrips,
  };
}
